<div *ngIf="scheduleData" style="min-height: 100%;">
  <div id="print-section">
    <div class="pt-3 container">
      <div class="mb-2">
        <h4 id="schedule-company-participant-text">{{scheduleData.name}}</h4>
        <p id="schedule-company-company-text" class="text-muted mb-0">{{scheduleData.companyName}}</p>
      </div>
      <div class="d-flex justify-content-between align-items-end mb-3">
        <div id="time-timezone-text" class="text-danger mt-1" *ngIf="scheduleData.eventType === eventTypeEnum.THAILANDFOCUS">
          Timezone : {{now | date:'zzz': timezone}} (Bangkok time). The event will be conducted in physical event
        </div>
        <button type="button" class="btn btn-primary no-print" (click)="convertToPDF()"><i class="fas fa-download mr-2"></i>Download as PDF</button>
      </div>

      <div class="schedule-table-scroll">
        <ng-container *ngFor="let slot of scheduleData.slots; let slotIndex = index;">
          <div class="schedule-table-wrapper" *ngIf="slot.slotPeriods && slot.slotPeriods.length > 0">
            <table class="table meeting-schedule-table">
              <colgroup>
                <col class="col-time">
                <col class="col-room">
                <col class="col-speaker">
                <col class="col-investor">
                <col class="col-meeting-type">
              </colgroup>
              <thead>
                <tr class="slot-date-row">
                  <th colspan="5">
                    <strong id="schedule-company-field-slot-date-text-{{slotIndex}}">{{slot.slotDate | date:'mediumDate': scheduleData.eventType === eventTypeEnum.THAILANDFOCUS ? 'UTC +7' : ''}}</strong>
                  </th>
                </tr>
                <tr class="header-row">
                  <th id="schedule-company-feild-date-column-text">Date/Time</th>
                  <th id="schedule-company-feild-room-column-text">Room</th>
                  <th id="schedule-company-feild-participant-column-text">Speaker</th>
                  <th id="schedule-company-feild-investor-column-text">Investor</th>
                  <th id="schedule-company-feild-meeting-type-column-text" class="text-center">Meeting Type</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let slotPeriod of slot.slotPeriods; let periodIndex = index;">
                  <td>
                    <span id="schedule-company-field-period-text-{{slotIndex}}-{{periodIndex}}">
                      {{slotPeriod.startTime | date:'HH:mm': timezone}} - {{slotPeriod.endTime | date:'HH:mm': timezone}}
                    </span>
                    <div *ngIf="scheduleData.eventType === eventTypeEnum.THAILANDFOCUS && slotPeriod.isSubEvent"
                        class="sub-event-label">Corporate Briefing
                    </div>
                  </td>
                  <td>
                    <div id="schedule-company-field-room-link-text-{{slotIndex}}-{{periodIndex}}">{{slotPeriod.room || '-'}}</div>
                    <a *ngIf="slotPeriod.roomLink" [tooltip]="slotPeriod.roomDesc" id="schedule-company-field-meetinig-room-link-text-{{slotIndex}}-{{periodIndex}}"
                      target="_blank" [href]="slotPeriod.roomLink" class="link-blue">Meeting Link <img
                        src="assets/images/video.svg" alt=""></a>
                  </td>
                  <td>
                    <div *ngFor="let participant of slotPeriod.participants; let participantIndex = index;" class="speaker-row">
                      <div class="speaker-name" [class.speaker-name-login]="participant.name === scheduleData.name"
                        id="schedule-company-field-participant-name-text-{{slotIndex}}-{{periodIndex}}-{{participantIndex}}">
                        {{participant.name || '-'}}
                      </div>
                      <div class="speaker-job" *ngIf="participant.jobTitle"
                        id="schedule-company-field-participant-job-text-{{slotIndex}}-{{periodIndex}}-{{participantIndex}}">
                        {{participant.jobTitle}}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div *ngFor="let attendee of slotPeriod.attendees; let i = index;">
                      <div *ngIf="i < 3 || slotPeriod['isShow']" class="attendee-row">
                        <div class="attendee-name" id="schedule-company-field-attendee-name-text-{{slotIndex}}-{{periodIndex}}-{{i}}">
                          {{attendee.name}}
                        </div>
                        <div class="attendee-company" *ngIf="attendee.companyName"
                          id="schedule-company-field-attendee-company-text-{{slotIndex}}-{{periodIndex}}-{{i}}">
                          {{attendee.companyName}}
                        </div>
                      </div>
                      <a *ngIf="slotPeriod.attendees.length > 3 && i == 2 && !slotPeriod['isShow']"
                        id="schedule-company-field-attendee-show-more-text-{{slotIndex}}-{{periodIndex}}-{{i}}"
                        (click)="slotPeriod['isShow'] = true" class="show-more-link">show more</a>
                      <a *ngIf="slotPeriod.attendees.length > 3 && slotPeriod['isShow'] && i === (slotPeriod.attendees.length - 1)"
                        id="schedule-company-field-attendee-show-less-text-{{slotIndex}}-{{periodIndex}}-{{i}}"
                        (click)="slotPeriod['isShow'] = false" class="show-more-link">show less</a>
                    </div>
                  </td>
                  <td class="text-center">
                    <span [ngClass]="{'badge--meeting-type': slotPeriod.meetingType === 'VIRTUALGROUP'}">{{slotPeriod.meetingType | meetingType}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="mx-5 px-5 pt-4" *ngIf="isErr">
    <h6 id="schedule-company-line1-error-text">ERROR</h6>
    <h3 id="schedule-company-line2-error-text">PAGE NOT FOUND</h3>
    <p id="schedule-company-line3-error-text">The page you requested was not found.</p>
  </div>
</div>
